// frontend/src/pages/PrivacyPolicy.jsx
import React from "react";
import Layout from "../components/Layout";

function PrivacyPolicy() {
  return (
    <Layout>
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="card shadow-sm">
              <div className="card-body p-5">
                <h1 className="mb-4">Privacy Policy</h1>
                <p className="text-muted">
                  Last Updated: {new Date().toLocaleDateString()}
                </p>
                <hr className="my-4" />
                <section className="mb-5">
                  <h2 className="h4 mb-3">1. Introduction</h2>
                  <p>
                    WebVenly ("we," "our," or "us") is committed to protecting
                    your privacy. This Privacy Policy explains how we collect,
                    use, disclose, and safeguard your information when you use
                    our rehabilitation services management platform and related
                    services.
                  </p>
                </section>
                <section className="mb-5">
                  <h2 className="h4 mb-3">2. Information We Collect</h2>
                  <h5 className="h6 mt-3">Personal Information</h5>
                  <p>
                    We may collect personal information that you provide
                    directly to us, including:
                  </p>
                  <ul>
                    <li>
                      Name and contact information (email address, phone number)
                    </li>
                    <li>Organization/company name and address</li>
                    <li>Account credentials</li>
                    <li>Billing and payment information</li>
                    <li>
                      Professional information related to rehabilitation
                      services
                    </li>
                  </ul>

                  <h5 className="h6 mt-3">Usage Information</h5>
                  <p>
                    We automatically collect certain information when you use
                    our services:
                  </p>
                  <ul>
                    <li>Device and browser information</li>
                    <li>IP address and location data</li>
                    <li>Usage patterns and preferences</li>
                    <li>Log data and analytics</li>
                  </ul>
                </section>
                <section className="mb-5">
                  <h2 className="h4 mb-3">3. How We Use Your Information</h2>
                  <p>We use the collected information to:</p>
                  <ul>
                    <li>Provide, maintain, and improve our services</li>
                    <li>Process transactions and manage your account</li>
                    <li>Send administrative information and updates</li>
                    <li>Respond to your comments, questions, and requests</li>
                    <li>Send marketing communications (with your consent)</li>
                    <li>
                      Monitor and analyze usage patterns to improve user
                      experience
                    </li>
                    <li>Comply with legal obligations</li>
                  </ul>
                </section>
                <section className="mb-5">
                  <h2 className="h4 mb-3">
                    4. Information Sharing and Disclosure
                  </h2>
                  <p>
                    We do not sell, trade, or rent your personal information. We
                    may share your information with:
                  </p>
                  <ul>
                    <li>
                      <strong>Service Providers:</strong> Third-party vendors
                      who help us operate our business
                    </li>
                    <li>
                      <strong>Business Transfers:</strong> In connection with
                      any merger, sale, or acquisition
                    </li>
                    <li>
                      <strong>Legal Requirements:</strong> When required by law
                      or to protect rights and safety
                    </li>
                    <li>
                      <strong>Consent:</strong> With your explicit consent
                    </li>
                  </ul>
                </section>
                <section className="mb-5">
                  <h2 className="h4 mb-3">5. Data Security</h2>
                  <p>
                    We implement appropriate technical and organizational
                    security measures to protect your personal information
                    against unauthorized access, alteration, disclosure, or
                    destruction. These measures include:
                  </p>
                  <ul>
                    <li>Encryption of data in transit and at rest</li>
                    <li>Regular security assessments and updates</li>
                    <li>Access controls and authentication requirements</li>
                    <li>Employee training on data protection</li>
                  </ul>
                  <p className="mt-3">
                    <small className="text-muted">
                      However, no method of transmission over the Internet is
                      100% secure, and we cannot guarantee absolute security of
                      your information.
                    </small>
                  </p>
                </section>
                <section className="mb-5">
                  <h2 className="h4 mb-3">6. Your Rights and Choices</h2>
                  <p>You have the right to:</p>
                  <ul>
                    <li>
                      <strong>Access:</strong> Request access to your personal
                      information
                    </li>
                    <li>
                      <strong>Correction:</strong> Request correction of
                      inaccurate information
                    </li>
                    <li>
                      <strong>Deletion:</strong> Request deletion of your
                      information (subject to legal requirements)
                    </li>
                    <li>
                      <strong>Opt-out:</strong> Unsubscribe from marketing
                      communications
                    </li>
                    <li>
                      <strong>Data Portability:</strong> Request a copy of your
                      data in a structured format
                    </li>
                  </ul>
                  <p>
                    To exercise these rights, please contact us at{" "}
                    <a href="mailto:privacy@webvenly.com">
                      privacy@webvenly.com
                    </a>
                    .
                  </p>
                </section>
                <section className="mb-5">
                  <h2 className="h4 mb-3">
                    7. Cookies and Tracking Technologies
                  </h2>
                  <p>
                    We use cookies and similar tracking technologies to track
                    activity on our website and store certain information. You
                    can instruct your browser to refuse all cookies or to
                    indicate when a cookie is being sent. However, some features
                    of our services may not function properly without cookies.
                  </p>
                </section>
                <section className="mb-5">
                  <h2 className="h4 mb-3">8. Third-Party Services</h2>
                  <p>
                    Our services may contain links to third-party websites and
                    services. We are not responsible for the privacy practices
                    of these third parties. We encourage you to review their
                    privacy policies before providing any personal information.
                  </p>
                </section>

                <section className="mb-5">
                  <h2 className="h4 mb-3">9. Children's Privacy</h2>
                  <h5 className="h6 mt-3">Direct Use of Our Platform</h5>
                  <p>
                    WebVenly's platform is designed for use by rehabilitation
                    service professionals and organizations. We do not intend
                    for children under 18 to directly create accounts or use our
                    services. We do not knowingly collect personal information
                    directly from children under 18 for platform access.
                  </p>

                  <h5 className="h6 mt-3">
                    Consumer Information in Service Records
                  </h5>
                  <p>
                    Our platform enables rehabilitation service providers to
                    manage consumer cases, which may include information about
                    minors receiving rehabilitation services. When our users
                    (service providers) enter information about their consumers
                    who are minors, this is:
                  </p>
                  <ul>
                    <li>
                      Collected under the direction and authority of the service
                      provider
                    </li>
                    <li>
                      Subject to the service provider's own privacy policies and
                      legal obligations
                    </li>
                    <li>
                      Processed by us solely as a data processor on behalf of
                      the service provider
                    </li>
                    <li>
                      Protected with the same security measures as all consumer
                      data
                    </li>
                  </ul>

                  <h5 className="h6 mt-3">Service Provider Responsibilities</h5>
                  <p>
                    Service providers using our platform are responsible for:
                  </p>
                  <ul>
                    <li>
                      Obtaining appropriate consent for collecting minor
                      consumer information
                    </li>
                    <li>
                      Complying with applicable laws regarding minors' data
                      (COPPA, FERPA, etc.)
                    </li>
                    <li>
                      Ensuring they have legal authority to input and manage
                      such information
                    </li>
                    <li>
                      Maintaining their own privacy policies for their consumer
                      relationships
                    </li>
                  </ul>

                  <p className="mt-3">
                    <small className="text-muted">
                      If you believe a child under 18 has directly created an
                      account with us or if you have concerns about minor
                      consumer data, please contact us immediately at{" "}
                      <a href="mailto:privacy@webvenly.com">
                        privacy@webvenly.com
                      </a>
                      .
                    </small>
                  </p>
                </section>
                <section className="mb-5">
                  <h2 className="h4 mb-3">10. Data Retention</h2>
                  <p>
                    We retain your personal information for as long as necessary
                    to fulfill the purposes outlined in this Privacy Policy,
                    unless a longer retention period is required or permitted by
                    law. When we no longer need your information, we will
                    securely delete or anonymize it.
                  </p>
                </section>
                <section className="mb-5">
                  <h2 className="h4 mb-3">11. International Data Transfers</h2>
                  <p>
                    Your information may be transferred to and processed in
                    countries other than your own. These countries may have
                    different data protection laws. By using our services, you
                    consent to the transfer of your information to these
                    countries.
                  </p>
                </section>
                <section className="mb-5">
                  <h2 className="h4 mb-3">
                    12. Changes to This Privacy Policy
                  </h2>
                  <p>
                    We may update this Privacy Policy from time to time. We will
                    notify you of any changes by posting the new Privacy Policy
                    on this page and updating the "Last Updated" date. Your
                    continued use of our services after any changes indicates
                    your acceptance of the updated Privacy Policy.
                  </p>
                </section>
                <section className="mb-5">
                  <h2 className="h4 mb-3">13. Contact Us</h2>
                  <p>
                    If you have any questions or concerns about this Privacy
                    Policy, please contact us at:
                  </p>
                  <div className="bg-light p-4 rounded">
                    <p className="mb-2">
                      <strong>WebVenly</strong>
                      <br />
                      Wyatt Multi Solutions
                      <br />
                      Email:{" "}
                      <a href="mailto:privacy@webvenly.com">
                        privacy@webvenly.com
                      </a>
                      <br />
                      Phone: <a href="tel:681-363-0183">681-363-0183</a>
                      <br />
                      Support:{" "}
                      <a href="mailto:support@webvenly.com">
                        support@webvenly.com
                      </a>
                    </p>
                  </div>
                </section>
                <hr className="my-4" />
                <div className="text-center">
                  <a href="/" className="btn btn-primary me-2">
                    <i className="bi bi-house me-2"></i>
                    Return Home
                  </a>
                  <a href="/contact" className="btn btn-outline-secondary">
                    <i className="bi bi-envelope me-2"></i>
                    Contact Us
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default PrivacyPolicy;
